export enum DataType {
  ENERGY = 'energy',
  POWER = 'power',
}